import React from 'react';
import PropTypes from 'prop-types';
import If from '../../../Shared/If/If';
import { isRetirementDatedFund } from '../../../../utils/funds/funds-utility';
import summitIcon from '../../../../assets/images/scs-icons/summit-icon.svg';
import helpIcon from '../../../../assets/images/scs-icons/help-icon.svg';
import IClassFundToolTip from './IClassFundToolTip';

import './InlineMessage.scss';

function FundConversionThresholdInlinemessage({ fund }) {
  const { name, ticker } = fund;
  const isRDF = isRetirementDatedFund(ticker);
  return (
    <div className="inline-fund-message">
      <If test={!isRDF}>
        <p>
          <span className="inline-icon-wrapper">
            <img alt="summit icon" src={summitIcon} className="inline-icon" />
          </span>
          <span className="inline-msg-wrapper">
            You become eligible to convert to lower cost{' '}
            <IClassFundToolTip fundName={name} /> by reaching the $50,000 fund
            minimum, per fund.
          </span>
        </p>
      </If>
      <If test={isRDF}>
        <p>
          <span className="inline-icon-wrapper">
            <img alt="help icon" src={helpIcon} className="inline-icon" />
          </span>
          <span className="inline-msg-wrapper">
            You become eligible to convert to lower cost{' '}
            <IClassFundToolTip fundName={name} /> by reaching the $50,000 fund
            minimum, per fund.
            <br />
            Call 1-800-779-4393 and talk to a representative to learn more.
          </span>
        </p>
      </If>
    </div>
  );
}

FundConversionThresholdInlinemessage.propTypes = {
  fund: PropTypes.object,
};

export default FundConversionThresholdInlinemessage;
